import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { HighlightedRate } from '@/share/HighlightedRate/HighlightedRate';
import { Spinner } from '@/share/Spinner/Spinner';
import { getFormattedForwardPoints, getFormattedForwardRate, getFormattedSpotRate, selectRfs } from '@/store/state/rfs/rfs.selectors';
import { selectCurrentLocale } from '@/store/state/ui/ui.selectors';

export function ForwardRate() {
  const locale = useSelector(selectCurrentLocale);
  const rfs = useSelector(selectRfs);

  const waitingForPrice = rfs.status === 'requesting';
  const spotRate = getFormattedSpotRate(locale)(rfs);
  const forwardPoints = getFormattedForwardPoints(locale)(rfs);
  const forwardRate = getFormattedForwardRate(locale)(rfs);

  return (
    <>
      <div className="form-group col-6 p-md-0">
        <label className="text-secondary text-large mb-2">
          <FormattedMessage id="trader.forwardRate.forwardRate" />
        </label>
        <div className="display-4 tabular-figures fw-normal" data-e2e="forward-rate">
          {waitingForPrice ?
            <Spinner />
          : forwardRate !== undefined && <HighlightedRate value={forwardRate} offset={1} size={3} />}
        </div>
      </div>
      <div className="col-6 p-0">
        <div className="form-group d-flex justify-content-between align-items-end">
          <label className="text-secondary m-0">
            <FormattedMessage id="trader.forwardRate.spotRate" />
          </label>
          <span className="display-5 tabular-figures fw-normal" data-e2e="spot-rate">
            {waitingForPrice ?
              <Spinner />
            : spotRate !== undefined && <HighlightedRate value={spotRate} size={4} />}
          </span>
        </div>
        <div className="form-group d-flex justify-content-between mt-3">
          <label className="text-secondary">
            <FormattedMessage id="trader.forwardRate.forwardPoints" />
          </label>
          <span className="display-5 tabular-figures fw-normal" data-e2e="forward-points">
            {waitingForPrice ?
              <Spinner />
            : forwardPoints}
          </span>
        </div>
      </div>
    </>
  );
}
